module.exports = __webpack_public_path__ + "img/feature-isento-taxas.66e118e7.svg";